
function reflow(el) {
  return el && el.offsetHeight
}

export default {
  name: 'WithAccordion',

  props: {
    show: {
      type: Boolean,
      default: false
    },

    speed: {
      type: String,
      default: '300'
    },

    disableAnimation: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      inTransition: false
    }
  },

  methods: {
    onEnter(el) {
      el.style.height = 0
      reflow(el)
      el.style.height = el.scrollHeight + 'px'
      this.inTransition = true
    },
    onAfterEnter(el) {
      el.style.height = null
      this.inTransition = false
    },
    onLeave(el) {
      el.style.height = 'auto'
      el.style.display = 'block'
      el.style.height = el.getBoundingClientRect().height + 'px'
      reflow(el)
      this.inTransition = true
      el.style.height = 0
    },
    onAfterLeave(el) {
      el.style.height = null
      this.inTransition = false
    }
  },

  render(h) {
    const content = h(
      'div',
      {
        directives: [{ name: 'show', value: this.show }],
        class: {
          'is-showing': this.show && !this.inTransition,
          'collapse': !this.inTransition
        },
        style: {
          'transition-duration': `${this.speed}ms`
        }
      },
      this.$slots.default
    )

    return this.disableAnimation
      ? content
      : h(
          'transition',
          {
            props: {
              enterClass: '',
              enterActiveClass: 'collapsing',
              enterToClass: '',
              leaveClass: '',
              leaveActiveClass: 'collapsing',
              leaveToClass: ''
            },
            on: {
              enter: this.onEnter,
              afterEnter: this.onAfterEnter,
              leave: this.onLeave,
              afterLeave: this.onAfterLeave
            },
            attrs: {
              'aria-expanded': this.show
            }
          },
          [content]
        )
  }
}
